module.exports = __webpack_public_path__ + "746b9ea33a902ed45485022d73e9339e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folders_person_unactivated_2x.png
// module id = 19
// module chunks = 0 1 2 3 4